export default __webpack_public_path__ + "static/media/edit1.1b843462.png";